// Single source of truth for contact info
export const BRAND = "Sarkar Services";
export const PHONE_RAW = "+918884169160"; // E.164 format
export const PHONE_DISPLAY = "+91 88841 69160";
export const WHATSAPP_RAW = "918884169160";
export const WHATSAPP_MSG = encodeURIComponent(
  "Hi Sarkar Services, I am looking for washing machine service in bangalore"
);
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_RAW}?text=${WHATSAPP_MSG}`;
export const TEL_LINK = `tel:${PHONE_RAW}`;

// Fires Google Ads "Lead" conversion. Safe to call from any click handler;
// does NOT intercept navigation (the href/target on the link continues to work).
export const trackLeadConversion = () => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag_report_conversion === "function") {
      window.gtag_report_conversion();
    }
  } catch (e) {
    // swallow — never block the user from calling/WhatsApping
  }
};
